// extracted by mini-css-extract-plugin
export var item = "AltLoginsForm-module__item___LU0ud";